export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";

export const USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST";
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";


export const USER_REFRESH_TOKEN_SUCCESS = "USER_REFRESH_TOKEN_SUCCESS";
export const USER_REFRESH_TOKEN_REQUEST = "USER_REFRESH_TOKEN_REQUEST";
export const USER_REFRESH_TOKEN_FAIL = "USER_REFRESH_TOKEN_FAIL";
